import React, { Component } from 'react';
import PropTypes from 'prop-types';
import every from 'lodash/every';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';
import set from 'lodash/set';
import some from 'lodash/some';
import Cleave from 'cleave.js/dist/cleave-react';
import ModalConfirmation from '../ModalConfirmation';
import FormattedAddress from '../FormattedAddress';
import ModalClientDetails from '../ModalClientDetails';
import AddressForm from '../AddressForm';
import * as analytics from '../../services/analytics';
import './BOAEnrollmentPolicyholderView.css';

const propTypes = {
  client: PropTypes.object,
  onNotifyError: PropTypes.func,
  onNotifySuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  quote: PropTypes.object,
  updateClient: PropTypes.func,
  updateQuote: PropTypes.func,
};

function ShareLinkDetails({
  editingClient,
  titleAtBusiness,
  handleNewClientUpdate,
  handlePhoneInit,
  handleInlinePhoneUpdate,
  handleInlineAddressUpdate,
  handleTitleUpdate,
}) {
  return (
    <>
      <h3 className="text-center semi-bold">Tell us about your business</h3>
      <div className="BOAEnrollmentPolicyholderView-clientDetails card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">
            POLICYHOLDER DETAILS
          </label>
          <div className="col-md-9">
            <div className="form-group p-t-0">
              <label htmlFor="company" className="text-uppercase">
                Business name
              </label>
              <input
                type="text"
                className="form-control"
                id="company"
                name="person.company_name"
                value={get(editingClient, 'person.company_name') || ''}
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="firstName" className="text-uppercase">
                First name
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="person.first_name"
                value={get(editingClient, 'person.first_name') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName" className="text-uppercase">
                Last name
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="person.last_name"
                value={get(editingClient, 'person.last_name') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="text-uppercase">
                Email
              </label>
              <input
                type="text"
                className="form-control"
                id="email"
                name="person.email"
                value={get(editingClient, 'person.email') || ''}
                required
                aria-required="true"
                onChange={handleNewClientUpdate}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone" className="text-uppercase">
                Phone
              </label>
              <Cleave
                id="phone"
                className="form-control"
                name="person.phone_number"
                required
                options={{
                  blocks: [3, 3, 4],
                  delimiter: '-',
                  numericOnly: true,
                }}
                value={get(editingClient, 'person.phone_number') || ''}
                onInit={handlePhoneInit}
                onChange={handleInlinePhoneUpdate}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="BOAEnrollmentPolicyholderView-clientAddress card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">Business address</label>
          <div className="col-md-9">
            <AddressForm
              address={get(editingClient, 'person.address')}
              onChange={handleInlineAddressUpdate}
            />
          </div>
        </div>
      </div>

      <div className="BOAEnrollmentPolicyholderView-policyholderTitle card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">POLICYHOLDER TITLE</label>
          <div className="col-md-9">
            <div className="form-group p-t-0">
              <label htmlFor="policyholderTitle" className="text-uppercase">
                Title of position at company
              </label>
              <input
                id="policyholderTitle"
                className="form-control"
                name="titleAtBusiness"
                required
                value={titleAtBusiness || ''}
                onChange={handleTitleUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function QuoteDetails({
  client,
  editingClient,
  titleAtBusiness,
  showUpdateClientModal,
  isBusinessAddressComplete,
  handlePhoneInit,
  handleInlinePhoneUpdate,
  handleInlineAddressUpdate,
  handleTitleUpdate,
}) {
  return (
    <>
      <h3 className="text-center semi-bold">Tell us about your business</h3>
      <div className="BOAEnrollmentPolicyholderView-clientDetails card m-t-20">
        <div className="card-block form-group row">
          <label className="col-md-3 text-uppercase">
            Policyholder details
          </label>
          <div className="col-md-7">
            <p>
              {editingClient.person.company_name && (
                <>
                  <strong>{editingClient.person.company_name}</strong>
                  <br />
                </>
              )}
              {`${editingClient.person.first_name} ${editingClient.person.last_name}`}
              <br />
              Email: {editingClient.person.email}
              <br />
              {get(client, 'person.phone_number') && (
                <span>Phone: {client.person.phone_number}</span>
              )}
            </p>
          </div>
          <div className="col-md-2">
            <a
              href="#update-client"
              className="BOAEnrollmentPolicyholderView-clientDetails-edit text-complete float-right bold"
              onClick={showUpdateClientModal}
            >
              Edit
            </a>
          </div>
        </div>
        {isBusinessAddressComplete && (
          <div className="card-block form-group row">
            <label className="col-md-3 semi-bold text-uppercase">
              Business address
            </label>
            <div className="col-md-9">
              <FormattedAddress address={editingClient.person.address} />
            </div>
          </div>
        )}
      </div>

      {!get(client, 'person.phone_number') && (
        <div className="BOAEnrollmentPolicyholderView-clientPhone card m-t-20">
          <div className="card-block form-group row">
            <label className="col-md-3 text-uppercase">Phone number</label>
            <div className="col-md-9">
              <div className="form-group p-t-0">
                <label htmlFor="phoneNumber" className="text-uppercase">
                  Phone
                </label>
                <Cleave
                  id="phone"
                  className="form-control"
                  name="person.phone_number"
                  required
                  options={{
                    blocks: [3, 3, 4],
                    delimiter: '-',
                    numericOnly: true,
                  }}
                  value={get(editingClient, 'person.phone_number') || ''}
                  onInit={handlePhoneInit}
                  onChange={handleInlinePhoneUpdate}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {!isBusinessAddressComplete && (
        <div className="BOAEnrollmentPolicyholderView-clientAddress card m-t-20">
          <div className="card-block form-group row">
            <label className="col-md-3 text-uppercase">Business address</label>
            <div className="col-md-9">
              <AddressForm
                address={editingClient.person.address}
                onChange={handleInlineAddressUpdate}
              />
            </div>
          </div>
        </div>
      )}

      <div className="BOAEnrollmentPolicyholderView-policyholderTitle card m-t-20">
        <div className="card-block form-group row">
          <div className="col-md-3" />
          <div className="col-md-9">
            <div className="form-group p-t-0">
              <label htmlFor="policyholderTitle" className="text-uppercase">
                Title of recipient at company
              </label>
              <input
                id="policyholderTitle"
                className="form-control"
                name="titleAtBusiness"
                required
                value={titleAtBusiness || ''}
                onChange={handleTitleUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

class BOAEnrollmentPolicyholderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingClient: merge({}, props.client),
      isSubmitting: false,
      hasConfirmedRegionChange: false,
      titleAtBusiness:
        get(props, 'quote.application.holders[0].title_at_business') || '',
    };
  }

  componentDidMount() {
    const { client, getClient, quote, isShareLinkFlow } = this.props;
    analytics.page('BOA - Enrollment Policyholder');
    window.scrollTo(0, 0);
    !isShareLinkFlow && getClient(client.id);
    if (
      get(client, 'person.address.region.code') !==
      get(quote, 'application.rating_address.region.code')
    ) {
      this.setState((state) => ({
        editingClient: {
          ...state.editingClient,
          person: {
            ...state.editingClient.person,
            address: {
              region: get(quote, 'application.rating_address.region'),
            },
          },
        },
      }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevState.hasConfirmedRegionChange &&
      this.state.hasConfirmedRegionChange
    ) {
      this.handleNext();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.client, this.props.client)) {
      this.setState({
        editingClient: merge({}, nextProps.client),
      });
    }
  }

  componentWillUnmount() {
    this.updateClientModal.hide();
    this.confirmationModal.hide();
  }

  handlePhoneInit = (cleave) => {
    this.cleave = cleave;
    cleave.setRawValue(get(this.props.client, 'person.phone_number'));
  };

  handleInlinePhoneUpdate = (e) => {
    const { editingClient } = this.state;
    this.setState({
      editingClient: {
        ...editingClient,
        person: merge({}, editingClient.person, {
          phone_number: e.target.value,
        }),
      },
    });
  };

  handleTitleUpdate = (e) => {
    this.setState({
      titleAtBusiness: e.target.value,
    });
  };

  handleNewClientUpdate = (e) => {
    const editingClient = {
      ...this.state.editingClient,
    };
    set(editingClient, e.target.name, e.target.value);
    this.setState({
      editingClient,
    });
  };

  handleInlineAddressUpdate = (e) => {
    const { editingClient } = this.state;
    let key = e.target.name;
    let val = e.target.value;
    const newPerson = {
      ...editingClient.person,
    };
    set(newPerson, key, val);
    this.setState({
      editingClient: {
        ...editingClient,
        person: merge({}, editingClient.person, newPerson),
      },
    });
  };

  handleModalUpdate = (clientDetails) => {
    analytics.track('Broker Portal - Update Client Submitted');
    this.props
      .updateClient(clientDetails)
      .then((client) => {
        analytics.track('Broker Portal - Update Client Succeeded');
        this.setState({
          editingClient: client,
        });
        this.updateClientModal.hide();
      })
      .catch((error) => {
        analytics.track('Broker Portal - Update Client Failed');
        this.props.onNotifyError(error);
      });
  };

  handleNextWithoutQuote = () => {
    const { onSubmit, createQuote, getPlans, onNotifyError, broker } =
      this.props;
    const { editingClient, titleAtBusiness } = this.state;

    this.setState({
      isSubmitting: true,
    });

    const policyholder = {
      business_name: get(editingClient.person, 'company_name'),
      first_name: editingClient.person.first_name,
      last_name: editingClient.person.last_name,
      email: editingClient.person.email,
      phone_number: editingClient.person.phone_number,
      address: editingClient.person.address,
      position_on_policy: 1,
      title_at_business: titleAtBusiness,
    };
    // XXX: Hardcoding country until Google Maps Autocomplete implemented
    if (editingClient.person.address) {
      editingClient.person.address.country = {
        code: 'US',
        name: 'United States',
      };
    }

    const createdQuote = {
      broker: broker,
      verticalCode: 'chubb_boa',
      application: {
        client: { ...editingClient.person, client_type: 'business' },
        holders: [policyholder],
        rating_address: editingClient.person.address,
      },
    };
    createQuote(createdQuote)
      .then((quote) => {
        return getPlans(quote.quote_number).then(onSubmit);
      })
      .catch((error) => {
        this.setState({
          isSubmitting: false,
        });
        onNotifyError(error);
      });
  };

  handleNext = () => {
    const {
      client,
      quote,
      history,
      getClient,
      onSubmit,
      updateClient,
      updateQuote,
      onNotifyError,
    } = this.props;
    const { editingClient, titleAtBusiness } = this.state;
    if (
      get(editingClient.person, 'address.region.code') !==
        quote.application.rating_address.region.code &&
      !this.state.hasConfirmedRegionChange
    ) {
      this.showRegionChangeConfirmationModal();
    } else {
      const clientUpdatePromise = new Promise((resolve, reject) => {
        if (isEqual(editingClient, client)) {
          resolve(editingClient);
        } else {
          updateClient(editingClient).then(resolve, reject);
        }
      });

      this.setState({
        isSubmitting: true,
      });

      clientUpdatePromise
        .then(() => {
          return getClient(client.id);
        })
        .then((updatedClient) => {
          const policyholder = {
            ...updatedClient.person,
            position_on_policy: 1,
            business_name: editingClient.person.company_name,
            title_at_business: titleAtBusiness,
          };

          // XXX: Hardcoding country until Google Maps Autocomplete implemented
          if (updatedClient.person.address) {
            updatedClient.person.address.country = {
              code: 'US',
              name: 'United States',
            };
          }
          const updatedQuote = merge({}, quote, {
            application: {
              client: {
                ...updatedClient.person,
                client_type: updatedClient.client_type,
              },
              holders: [policyholder],
              rating_address: updatedClient.person.address,
            },
          });
          return updateQuote(updatedQuote);
        })
        .then(() => {
          if (!this.state.hasConfirmedRegionChange) {
            onSubmit();
          } else {
            history.push('plans');
          }
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });
          onNotifyError(error);
        });
    }
  };

  showUpdateClientModal = (e) => {
    e.preventDefault();
    analytics.track('Broker Portal - Edit Client Modal Opened');
    this.updateClientModal.show();
  };

  showRegionChangeConfirmationModal = (e) => {
    analytics.track('BOA - Change Region Modal Opened');
    this.confirmationModal.show();
  };

  handleConfirmRegionChange = () => {
    analytics.track('BOA - Change Region Modal Confirmed');
    this.setState({
      hasConfirmedRegionChange: true,
    });
    this.confirmationModal.hide();
  };

  handleCancelRegionChange = () => {
    analytics.track('BOA - Change Region Modal Cancelled');
    return;
  };

  get isBusinessAddressComplete() {
    const { editingClient } = this.state;
    return every(
      [
        get(editingClient, 'person.address.line1'),
        get(editingClient, 'person.address.city'),
        get(editingClient, 'person.address.region.code'),
        get(editingClient, 'person.address.postal'),
      ],
      Boolean
    );
  }

  get isNextDisabled() {
    const { isShareLinkFlow } = this.props;
    const { editingClient, isSubmitting, titleAtBusiness } = this.state;
    return (
      some(
        [
          get(editingClient, 'person.first_name'),
          get(editingClient, 'person.last_name'),
          get(editingClient, 'person.email'),
          get(editingClient, 'person.phone_number'),
          titleAtBusiness,
          get(editingClient, 'person.address.line1'),
          get(editingClient, 'person.address.city'),
          get(editingClient, 'person.address.region.code'),
          get(editingClient, 'person.address.postal'),
        ],
        isEmpty
      ) ||
      isSubmitting ||
      (isShareLinkFlow && isEmpty(get(editingClient, 'person.company_name')))
    );
  }

  render() {
    const { client, isUpdatingClient, isShareLinkFlow } = this.props;
    const { editingClient, titleAtBusiness } = this.state;

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            {isShareLinkFlow ? (
              <ShareLinkDetails
                editingClient={editingClient}
                titleAtBusiness={titleAtBusiness}
                handleNewClientUpdate={this.handleNewClientUpdate}
                handlePhoneInit={this.handlePhoneInit}
                handleInlinePhoneUpdate={this.handleInlinePhoneUpdate}
                handleInlineAddressUpdate={this.handleInlineAddressUpdate}
                handleTitleUpdate={this.handleTitleUpdate}
              />
            ) : (
              <QuoteDetails
                client={client}
                editingClient={editingClient}
                titleAtBusiness={titleAtBusiness}
                showUpdateClientModal={this.showUpdateClientModal}
                isBusinessAddressComplete={this.isBusinessAddressComplete}
                handlePhoneInit={this.handlePhoneInit}
                handleInlinePhoneUpdate={this.handleInlinePhoneUpdate}
                handleInlineAddressUpdate={this.handleInlineAddressUpdate}
                handleTitleUpdate={this.handleTitleUpdate}
              />
            )}

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={this.isNextDisabled}
                onClick={
                  isShareLinkFlow
                    ? this.handleNextWithoutQuote
                    : this.handleNext
                }
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <ModalClientDetails
          client={editingClient}
          isUpdatingClient={isUpdatingClient}
          isClientTypeVisible={false}
          isEditingExistingClient={true}
          onSubmit={this.handleModalUpdate}
          ref={(c) => (this.updateClientModal = c)}
        />
        <ModalConfirmation
          title="Confirm change to business state"
          confirmCta="Yes"
          onConfirm={this.handleConfirmRegionChange}
          onCancel={this.handleCancelRegionChange}
          ref={(c) => (this.confirmationModal = c)}
        >
          Changing the state where the business headquarters is located will
          alter the quoted price. Confirming this change will navigate you back
          to the plan overview, where the new price will be displayed. Are you
          sure you want to change the location?
        </ModalConfirmation>
      </div>
    );
  }
}

BOAEnrollmentPolicyholderView.propTypes = propTypes;

export default BOAEnrollmentPolicyholderView;
